import {
  Aktivitet,
  BebyggelseobjektPublicerad,
  BebyggelseobjektUtkast,
  BebyggelseobjektVersionHistorisk,
  BildResursData,
  EnkelinventeringAktivitet,
  GranskningBildMetadata,
  GranskningRitningMetadata,
  Inventering,
  KulturvardeForstortAktivitet,
  Migreringsaktivitet,
  ModelError,
  RitningResursData,
  Skyddsklassningsaktivitet,
  UpphovsmanTyp,
  Upphovsorganisation,
  Upphovsperson
} from 'models';

import { AktivitetstypEnum, DokumentationstypEnum, UpphovsmanTypEnum } from 'enums';

export const isUpphovsorganisation = (upphovsman: UpphovsmanTyp): upphovsman is Upphovsorganisation =>
  upphovsman.upphovsmantyp === UpphovsmanTypEnum.UPPHOVSORGANISATION;

export const isUpphovsperson = (upphovsman: UpphovsmanTyp): upphovsman is Upphovsperson =>
  upphovsman.upphovsmantyp === UpphovsmanTypEnum.UPPHOVSPERSON;

export const isGranskningBildMetadata = (
  metadata: GranskningBildMetadata | GranskningRitningMetadata
): metadata is GranskningBildMetadata =>
  'bildtext' in metadata &&
  'upphovsman_fornamn' in metadata &&
  metadata.dokumentationstyp === DokumentationstypEnum.BILD;

export const isGranskningRitningMetadata = (
  metadata: GranskningBildMetadata | GranskningRitningMetadata
): metadata is GranskningRitningMetadata =>
  'motivbeskrivning' in metadata && metadata.dokumentationstyp === DokumentationstypEnum.RITNING;

export const isBildResursData = (metadata: BildResursData | RitningResursData): metadata is BildResursData =>
  'bildtext' in metadata && 'upphovsman' in metadata && metadata.dokumentationstyp === DokumentationstypEnum.BILD;

export const isRitningResursdata = (metadata: BildResursData | RitningResursData): metadata is RitningResursData =>
  'motivbeskrivning' in metadata && metadata.dokumentationstyp === DokumentationstypEnum.RITNING;

export const isFetchBaseQueryModelError = (error: any): error is { data: ModelError } => 'status' in error;

export const isInventering = (aktivitet: Aktivitet): aktivitet is Inventering =>
  aktivitet.aktivitetstyp === AktivitetstypEnum.INVENTERING;

export const isSkyddsklassningsaktivitet = (aktivitet: Aktivitet): aktivitet is Skyddsklassningsaktivitet =>
  aktivitet.aktivitetstyp === AktivitetstypEnum.SKYDDSKLASSNING;

export const isMigreringsaktivitet = (aktivitet: Aktivitet): aktivitet is Migreringsaktivitet =>
  aktivitet.aktivitetstyp === AktivitetstypEnum.MIGRERING;

export const isEnkelinventering = (aktivitet: Aktivitet): aktivitet is EnkelinventeringAktivitet =>
  aktivitet.aktivitetstyp === AktivitetstypEnum.ENKELINVENTERING;

export const isKulturvardeForstort = (aktivitet: Aktivitet): aktivitet is KulturvardeForstortAktivitet =>
  aktivitet.aktivitetstyp === AktivitetstypEnum.KULTURVARDE_FORSTORT;

export const isBebyggelseobjektPublicerad = (
  bebyggelseobjekt: BebyggelseobjektPublicerad | BebyggelseobjektUtkast | BebyggelseobjektVersionHistorisk
): bebyggelseobjekt is BebyggelseobjektPublicerad => (bebyggelseobjekt as BebyggelseobjektPublicerad).uri !== undefined;

export const isBebyggelseobjektUtkast = (
  bebyggelseobjekt: BebyggelseobjektPublicerad | BebyggelseobjektUtkast | BebyggelseobjektVersionHistorisk
): bebyggelseobjekt is BebyggelseobjektUtkast => (bebyggelseobjekt as BebyggelseobjektUtkast).utkast_id !== undefined;
